'use client'

import { useState } from 'react'

import { Alert, AlertDescription } from '@/shared/ui/alert'
import { Button } from '@/shared/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'
import { Input } from '@/shared/ui/input'

interface BillingAuthFormProps {
    onAuthenticated: () => void
}

export function BillingAuthForm({ onAuthenticated }: BillingAuthFormProps) {
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handlePasswordSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (password === 'Bertie2013') {
            onAuthenticated()
            setError('')
        } else {
            setError('Contraseña incorrecta')
        }
    }

    return (
        <div className='container mx-auto flex min-h-[calc(100vh-200px)] items-center justify-center p-6'>
            <Card className='w-full max-w-md'>
                <CardHeader>
                    <CardTitle>Acceso a Facturación</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handlePasswordSubmit} className='space-y-4'>
                        <div className='space-y-2'>
                            <Input
                                type='password'
                                placeholder='Introduce la contraseña'
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </div>
                        {error && (
                            <Alert variant='destructive'>
                                <AlertDescription>{error}</AlertDescription>
                            </Alert>
                        )}
                        <Button type='submit' className='w-full'>
                            Acceder
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
